export default {
  data: {},
};
